/* eslint-disable jsx-a11y/alt-text */
import classes from './Main.module.scss'
import React, { useContext } from 'react';
import styled from 'styled-components'
import {
  BrowserRouter as Router, Link
} from "react-router-dom";
import { LanguageContext } from '../../containers/Language';
import mainIMG from './img/main-img.png';



const Main = () => {

    const { dictionary, userLanguage } = useContext(LanguageContext);

    // const MainTitle = styled.h1`
    //     margin: 20px 0 25px;
    //     font-size: 4vw;
    //     font-weight: bold;
    //     line-height: 0.97;
    //     color: #314665;
    // `

    return (
        <div className={classes.main}>
            <div className={classes.center}>
                <div className={classes.left}>
                    <h3 dangerouslySetInnerHTML={{__html: dictionary.HYS}} className={classes.top_sentences} />
                    <h1 dangerouslySetInnerHTML={{__html: dictionary.MAIN_TITLE}} className={classes.big_sentences} />
                    <p dangerouslySetInnerHTML={{__html: dictionary.MAIN_SUBTITLE}} className={classes.bottom_sentences}/>

                    <Router>
                        <Link to={{ pathname: "https://mylife.az/onlineapp" }} 
                            target="_blank">
                            <button className={`btn btn-primary btn-lg ${classes.apply}`}>{dictionary.APPLY} <i className="fal fa-long-arrow-right"></i></button>
                        </Link>
                    </Router>
                    
                </div>
                <div className={classes.right}>
                    <img src={mainIMG} alt='Main Image'/>
                </div>
            </div>
        </div>
    )
}

export default Main
